<template>
  <div class="page noselect" :class="{withSearchbar: $store.getters.searchIsRenderedNow}">
    <!--        <div v-if="thisCategory.image && thisCategory.image.length > 0">-->
    <!--            <div class="mobile">-->
    <!--                <v-img-->
    <!--                        :src="thisCategory.image"-->
    <!--                        height="230px"-->
    <!--                        @click.native.passive="clickCatImage"-->
    <!--                ></v-img>-->
    <!--            </div>-->
    <!--            <div class="tablet">-->
    <!--                <v-container>-->
    <!--                    <v-img-->
    <!--                            :src="thisCategory.image"-->
    <!--                            height="250px"-->
    <!--                            :class="{pointer: productsOfCategory.length===1}"-->
    <!--                            @click.native.passive="clickCatImage"-->
    <!--                    ></v-img>-->
    <!--                </v-container>-->
    <!--            </div>-->
    <!--            &lt;!&ndash;            <div class="spacer-15"></div>&ndash;&gt;-->
    <!--        </div>-->

    <div class="" v-if="$store.state.showCatSlider">
      <!--            <div class="mobile">-->
      <!--                <h2 class="text-truncate">{{selectedCat.categoryDE}}</h2>-->
      <!--            </div>-->
      <v-container class="pt-0">
        <cat-slider class="mb-4"></cat-slider>
        <h1 class="">{{ selectedCat.categoryDE }}</h1>
      </v-container>
    </div>

    <div class="mt-5" v-else>
      <!--            <div class="mobile">-->
      <!--                <h2 class="text-truncate">{{selectedCat.categoryDE}}</h2>-->
      <!--            </div>-->
      <v-container>
        <h1 class="">{{ selectedCat.categoryDE }}</h1>
      </v-container>
    </div>


    <div v-if="showProducts">
      <!--            <div class="spacer-10"></div>-->

      <!--            <v-container class="hidden-sm-and-up">-->
      <!--                <div>-->
      <!--                    <v-list class="itemsList">-->
      <!--                        &lt;!&ndash;                    <v-divider></v-divider>&ndash;&gt;-->
      <!--                        &lt;!&ndash;                    <ItemsRow @click.native.passive="gotoItem(item)"&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                      :key="item.id"&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                      :isSection="!!item.section"&ndash;&gt;-->
      <!--                        &lt;!&ndash;                                      :item="item"></ItemsRow>&ndash;&gt;-->
      <!--                        <MobileItemsRow @click.native.passive="gotoItem(item)"-->
      <!--                                        v-for="(item, index) in productsOfCategory"-->
      <!--                                        :key="item.id"-->
      <!--                                        :item="item"></MobileItemsRow>-->
      <!--                    </v-list>-->
      <!--                </div>-->
      <!--            </v-container>-->


      <v-container grid-list-lg>
        <!--                class="hidden-xs-only"-->
        <v-layout row wrap class="withBorderLine">

          <v-flex xs12 v-for="(item, index) in productsOfCategory"
                  :class="{isSection: !!item.section, md6: !item.section, lg4: !item.section, md12: !!item.section, lg12: !!item.section}">
            <v-list class="itemsList" :class="{expanded : showItemExtras && currentItem.id === item.id}">
              <!--                    <v-divider></v-divider>-->
              <!--                            <QuickItemsRow-->
              <!--                                    @click.native.passive="clickItem(item)"-->
              <!--                                    :key="item.id"-->
              <!--                                    :isSection="!!item.section"-->
              <!--                                    :item="item"-->
              <!--                            ></QuickItemsRow>-->

              <ItemsRow
                :id="'irow'+index"
                :fordrinks="false"
                @click.native.passive="expandExtras(item, index)"
                @close="showItemExtras = false; currentItem={id:''}"
                :expanded="showItemExtras && currentItem.id === item.id"
                @expandExtrasForItem="expandExtras(item, index)"
                :key="item.id"
                :isSection="!!item.section"
                :item="item"></ItemsRow>
              <div class="prelative" style="padding-top: 6px" @click.passive.stop="noOp">
                <ItemExtrasOverlay
                  v-if="showItemExtras && currentItem.id === item.id"
                  :fordrinks="false"
                  :itemId="currentItem.id"
                  @wasAdded=""
                ></ItemExtrasOverlay>
              </div>


              <!--                            v-for="(item, index) in productsOfCategory"-->
            </v-list>
          </v-flex>

          <!--                &lt;!&ndash;            <div style=" transition: all 0.4s ease;">&ndash;&gt;-->
          <!--                &lt;!&ndash;            <h1 class="myTitle hidden-md-and-down">{{selectedCat.categoryDE}}</h1>&ndash;&gt;-->
          <!--                &lt;!&ndash;            <div class="spacer hidden-lg-and-up"></div>&ndash;&gt;-->

          <!--                <v-layout row wrap>-->
          <!--                    <v-flex xs12 sm6 md4 lg3 v-for="(item, index) in productsOfCategory">-->
          <!--                        <ProductCard class="pointer" @click.native.passive="gotoItem(item)" :item="item"></ProductCard>-->
          <!--                    </v-flex>-->
          <!--                </v-layout>-->
          <!--                &lt;!&ndash;            </div>&ndash;&gt;-->

        </v-layout>
      </v-container>
    </div>

    <!-- Trennlinie-->
    <v-container>
      <MyLine class="mt-5 mb-4"></MyLine>
    </v-container>

    <FoodCards></FoodCards>
    <DrinkCards></DrinkCards>

    <FixBasket></FixBasket>

  </div>
</template>

<script>
import {ebus} from '../vendor/ebus';
import store from '../store/store'
import * as qconst from '../vendor/qconstants';
import * as util from '../vendor/util'
import {getCurrentDevice} from '../vendor/breakpoints'
// import {gevent} from "../firebase/firebaseUtil";

// import {offerMixin} from "../mixins/offerMixin";
// import ProductCard from "../components/ProductCard";
// import CatSlider from "../components/CatSlider";
// import FixBasket from "../components/FixBasket";
import ItemsRow from "../components/ItemsRow";
import FixBasket from "../components/FixBasket";
import MobileItemsRow from "../components/MobileItemsRow";
import MyLine from "../components/MyLine";
import DrinkCards from "../components/DrinkCards";
import FoodCards from "../components/FoodCards";
import ItemExtrasOverlay from "../components/ItemExtrasOverlay";
import CatSlider from "@/components/CatSlider.vue";

export default {
  components: {
    CatSlider,
    ItemExtrasOverlay,
    FoodCards,
    DrinkCards,
    MyLine,
    MobileItemsRow,
    FixBasket,
    ItemsRow,
    // FixBasket,
    // CatSlider,
    // ProductCard
  },
  // mixins: [offerMixin],
  data: () => ({
    selectedCat: {id: '0', categoryDE: '', type: 'food'},
    foodCategories: [],
    filterClosed: true,
    thisCategory: {},
    // productsOfCategory: [],
    showProducts: true,

    currentItem: {},
    showItemExtras: false,
    selectedCatId: null,
  }),
  computed: {
    productsOfCategory() {
      try {
        let cats = util.cloneMe(store.getters.foodMenu);
        for (let cat of cats) {
          cat.type = 'food';
        }

        //preselect first cat
        if (cats.length > 0) {
          this.preselectFirstCat(cats);
        }

        let category = cats.find(c => c.id === this.selectedCatId);
        this.thisCategory = util.cloneMe(category);
        // this.showProducts = true;
        return category.items;
      } catch (e) {
        console.log('error in productsOfCategory: ' + e.message);
        return [];
      }
    }
  },
  watch: {
    '$route.params.catname': function (id) {
      // this.init();
      this.forceJump();
    },
    selectedCat: {
      handler: function handler(newVal, oldVal) {
        console.log('selection watched');
        if (newVal.type && newVal.type === 'food') {
          this.selectedCatId = newVal.id;
          // this.initProductsOfCat(newVal.id);
        }
      },
      deep: true,
    },
  },
  created() {
    ebus.$on('deviceClassesUpdated', () => {
      console.log('deviceClassesUpdated event');
      this.showItemExtras = false;
    });
    ebus.$on('offersUpdated', () => {
      this.init();
    });
    // ebus.$on(qconst.notify$foodsUpdated, () => {
    //   // let force = param && param.force;
    //   this.init();
    //   if (this.selectedCat.id !== '0') {
    //     //force update
    //     this.initProductsOfCat(this.selectedCat.id);
    //     // this.productsOfCategory = [];
    //     // setTimeout(() => {
    //     //     this.preselectFirstCat();//triggers update of productsOfCategory
    //     // }, 100);
    //   }
    // });
  },
  destroyed() {
    util.clearEvents([
      'deviceClassesUpdated',
      'offersUpdated',
      // qconst.notify$foodsUpdated,
    ]);
  },
  mounted() {
    // this.init();
    this.lazyJump();
    // this.ensureCatStore();
  },
  // activated() {
  //     this.lazyJump();
  //     // if (this.selectCategory.id !== store.state.selectedCategoryId) {
  //     //     let category = this.foodCategories.find(c => c.id === store.state.selectedCategoryId);
  //     //     if (category) {
  //     //         this.selectCategory(category);
  //     //     }
  //     // }
  //     // // this.init();
  //     // if (store.state.shouldJump) {
  //     //     setTimeout(() => {
  //     //         util.jumpToTop();
  //     //     }, 120);
  //     //     store.state.shouldJump = false;
  //     // }
  // },
  methods: {
    noOp() {
      return false;
    },
    expandExtras(itemToExpand, index) {
      if (itemToExpand.section) {
        return;
      }
      console.log('expandExtras...');
      if (this.showItemExtras && this.currentItem.id === itemToExpand.id) {
        this.showItemExtras = false;
        return;
      }
      if (qconst.useExtrasExpander && getCurrentDevice() === 'xs') {
        this.currentItem = itemToExpand;
        this.showItemExtras = true;
        // setTimeout(() => {
        util.delayScroll('irow' + index, 125);
        // },100);
      } else {
        this.gotoItem(itemToExpand);
      }
    },
    ensureCatStore() {
      // console.log('ensureCatStore');
      // let catname = this.$route.params.catname;
      // let retry = true;
      // if (catname && catname.length > 0 && catname !== ' all') {
      //   let cn = decodeURIComponent(catname);
      //   let selectedC = this.foodCategories.find(c => c.categoryDE === cn);
      //   if (selectedC) {
      //     retry = false;
      //     // if(!store.state.duringCatSelect){
      //     store.commit('selectedCategory', selectedC);
      //     // }
      //   }
      // }
      // if (retry) {
      //   //retry
      //   setTimeout(() => {
      //     this.ensureCatStore();
      //   }, 700);
      // }
    },
    updateModel(cat) {
      if (!cat.type) {
        // alert('food cat no type');
        return;
      }
      this.selectedCat.id = '' + cat.id;
      this.selectedCat.categoryDE = '' + cat.categoryDE;
    },

    selectCategory(cat) {
      console.log('SpeisenProdukte:: selectCategory ' + cat.categoryDE + ' type ' + cat.type);
      // if (rn.indexOf('Getraenk') !== -1 || rn.indexOf('Drink') !== -1) {
      //     console.log('prevented');
      //     return;
      // }
      if (cat.type) {
        if (cat.type === 'drink') {
          store.commit('selectedCategory', cat);
          this.$router.push({name: 'GetraenkeProdukte', params: {catname: cat.categoryDE}});
        } else {
          this.updateModel(cat);
          cat.type = 'food';
          store.commit('selectedCategory', cat);
        }
      }
    },
    clickCatImage() {
      if (this.productsOfCategory.length === 1) {
        this.gotoItem(this.productsOfCategory[0]);
      }
    },
    // initProductsOfCat(catId) {
    //   this.showProducts = false;
    //   let category = this.foodCategories.find(c => c.id === catId);
    //   this.thisCategory = util.cloneMe(category);
    //   this.productsOfCategory = util.cloneMe(category.items);
    //   // setTimeout(() => {
    //   this.showProducts = true;
    //
    //   // gevent('view_item_list', {
    //   //     item_list_name: category.categoryDE,
    //   // });
    //   // }, 50);
    // },
    forceJump() {
      if (!this.lazyJump()) {
        util.jumpToTop(true);
      }
    },
    lazyJump() {
      if (store.state.scrollTarget) {
        let t = '' + store.state.scrollTarget;
        let scrollIv = setInterval(() => {
          let el = document.getElementById(t);
          if (el) {
            util.clearTheInterval(scrollIv);
            util.delayScroll(t, 95);
          }
        }, 200);

        store.state.scrollTarget = '';
        return true;
      }
      return false;
    },
    gotoItem(item) {
      if (item.section) {
        return;
      }
      this.$router.push({name: 'Speise', params: {itemId: item.id}});
    },
    // replaceIcons() {
    //     setTimeout(() => {
    //         let iconNext = document.querySelector('.v-slide-group__next .v-icon');
    //         iconNext.textContent = 'chevron_right';
    //         iconNext.className = 'v-icon notranslate material-icons theme--light';
    //         iconNext.style.fontSize = 'xx-large';
    //         iconNext.setAttribute('x-large', '');
    //
    //         let iconPrev = document.querySelector('.v-slide-group__prev .v-icon');
    //         iconPrev.textContent = 'chevron_left';
    //         iconPrev.className = 'v-icon notranslate material-icons theme--light';
    //         iconPrev.style.fontSize = 'xx-large';
    //         iconPrev.setAttribute('x-large', '');
    //     }, 600);
    // },
    init() {
      let cats = util.cloneMe(store.getters.foodMenu);
      // console.log('so do we have cats??? ' + foodCats.length);
      for (let cat of cats) {
        cat.type = 'food';
        //     if (!fcat.items) {
        //         continue;
        //     }
        //     for (let item of fcat.items) {
        //         let offerAndItem = store.getters.getOfferByItemId(item.id);
        //         // item.offered = !!offerAndItem;
        //         // if (!!offerAndItem) {
        //         //     item.offerId = offerAndItem.offer.id;
        //         // }
        //         this.applyOfferAndPrices(item, offerAndItem);
        //     }
      }

      this.foodCategories = cats;

      //preselect first cat
      if (cats.length > 0) {
        this.preselectFirstCat();
      }
      console.log('number of cats in Produkte: ' + cats.length);
      // if (force) {
      //     this.foodCategories = [];
      //     setTimeout(() => {
      //         console.log('Produkte item1 = ' + foodCats[0].items[0].nameDE);
      //         this.foodCategories = foodCats;
      //     }, 400);
      // } else {

      // }

      // if (this.selectedCat.categoryDE.length === 0) {
      //     this.selectCategory(foodCats[0]);
      // }
    },
    preselectFirstCat(cats) {
      if (store.state.duringCatSelect) {
        if (store.getters.selectedCategory.type !== this.selectedCat.type) {
          console.log('type mismatch: store=' + store.getters.selectedCategory.type + ' local=' + this.selectedCat.type);
          return;
        }
        if (store.getters.selectedCategory.id === this.selectedCat.id) {
          return;
        }
      }
      let foodCats = cats;
      let catname = this.$route.params.catname;
      if (catname && catname.length > 0 && catname !== ' all') {
        let cn = decodeURIComponent(catname);
        let selectedC = foodCats.find(c => c.categoryDE === cn);
        if (selectedC) {
          this.selectCategory(selectedC);
        } else {
          this.selectCategory(foodCats[0]);
        }
        // } else if (store.state.selectedCategoryId.length > 0) {
        //     let selectedC = foodCats.find(c => c.id === store.state.selectedCategoryId);
        //     if (selectedC) {
        //         this.selectCategory(selectedC);
        //     } else {
        //         this.selectCategory(foodCats[0]);
        //     }
      } else {
        this.selectCategory(foodCats[0]);
      }
    },
    // clickFilter() {
    //     console.log('clickFilter');
    //     this.filterClosed = !this.filterClosed
    // },

  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.page ::v-deep .withBorderLine .v-list.itemsList {
  /*<!--border-bottom: 1px solid $accent;-->*/
  @include bgLinear;
  /*background-color: rgba(#dddddd, 0.2);*/
  @include material-shadow(1);
  padding-left: 12px;
  padding-bottom: 0 !important;
  margin: 2px 0 -2px 0;
  overflow-x: hidden;
  border-radius: $box-border-radius;

  &.expanded {
    //background-color: $lighted-accent;
  }
}

.page ::v-deep .withBorderLine .isSection .v-list.itemsList {
  background-color: transparent;
  box-shadow: none;
  border: none;
  /*.xs6:nth-last-child(2){*/
  /*    border-bottom: none;*/
  /*}*/
  /*.xs6:last-child{*/
  /*    border-bottom: none;*/
  /*}*/
}

.page ::v-deep .v-list.itemsList {
  background-color: transparent;
  height: 100%;
  padding-top: 5px;
}

/*.catSlider {*/
/*    position: fixed;*/
/*    top: 00px;*/
/*    left: 0;*/
/*    width: 100%;*/
/*}*/


/*.page .v-btn.v-size--large {*/
/*    font-size: 1.2em;*/
/*    height: 70px;*/
/*    border-right: 1px solid gray;*/
/*}*/

/* .fitem {
     margin: 0 10px;
 }

 .foverlay {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 00px;
 }


 .fix-filter {
     position: fixed;
     top: 00px;
     width: 100%;
 }

 .filter {
     background: $color-darkblue;
     color: white;
     padding: 15px;
     position: relative;

     &.closed {
         max-height: 62px;
         overflow: hidden;
     }
 }*/
</style>
